export default function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = e => {
            resolve(e.target.result.split(',').pop());
        };

        reader.onerror = reader.onabort = e => {
            reject(e);
        };

        reader.readAsDataURL(file);
    });
}



// WEBPACK FOOTER //
// ./src/utils/fileToBase64.js